import { GrowthBook } from "@growthbook/growthbook";

import store from '../store';
var  growthbook;
const featureFlag = {
  async connetGrowthBook() {
    growthbook = new GrowthBook({
      apiHost: "https://cdn.growthbook.io",
      clientKey: `${process.env.VUE_APP_FEATUREKEY}`,
      enableDevMode: true,
      subscribeToChanges: true,
      trackingCallback: (experiment, result) => {
        // TODO: Use your real analytics tracking system
        console.log("Viewed Experiment", {
          experimentId: experiment.key,
          variationId: result.key
        });
      }
    });
    this.setAttributes();
    await growthbook.loadFeatures();
  },
  setAttributes() {
    growthbook.setAttributes({
      'customer_id': store.state.customer.instance.id,
      'environment': process.env.VUE_APP_ENV,
      'loggedIn': true
    });
  
  },
  async isFeatureOn(featureName) {
    await growthbook.loadFeatures();
    return growthbook.isOn(featureName);
  },

  async valueFeature(featureName) {
    await growthbook.loadFeatures();
    return growthbook.getFeatureValue(featureName, null);
  }

}
export {
  featureFlag
}
